import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
    
    <   PageHeader {...page} 
        subheading="When to escalate to a live agent (if applicable), and what to say if no one's available or it's outside hours." >Escalations</PageHeader> 

        <SectionHeader {...page} subheading="A customer has asked to talk to a human team member." hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")}>Customer Initiated Escalation</SectionHeader>
        <SwitchRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")} keyName= {LocationVarKey.WantsCustomerInitiatedEscalations} label="Escalate to Human" />


        <SectionHeader {...page} subheading="If a bot has identified a sales opportunity, turning this on will escalate to a human team member." hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")}>Sales Opportunity</SectionHeader>
        <SwitchRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")} keyName= {LocationVarKey.WantsBotInitiatedEscalationsSales} label="Escalate to Human" />
        
        

        <SectionHeader {...page} subheading="If a bot has identified a service opportunity, turning this on will escalate to a human team member." hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")}>Service Opportunity</SectionHeader>
        <TextRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")}></TextRow>
        <SwitchRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")} keyName= {LocationVarKey.WantsBotInitiatedEscalationsService} label="Escalate to Human" />
        
        
        <SectionHeader {...page} subheading="If a bot is unsure how to answer a question, turning this on will escalate to a human team member." hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")}>Low Confidence</SectionHeader>
        <TextRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")}></TextRow>
        <SwitchRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")} keyName= {LocationVarKey.WantsBotInitiatedEscalationsLowConfidence} label="Escalate to Human" />
        




        
        <SectionHeader {...page} subheading="If no agents are available, the bot will respond with the information below." > No Agent Available - Sales</SectionHeader>
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.LiveChatNAASales1}
        />
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")}
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.LiveChatNAASales2}
            enableSwitchVar={LocationVarKey.LiveChatNAASales2Enabled}
        />
        <TextAreaRow {...page}  hideIf={IS_EQUAL(LocationVarKey.HasLiveChat,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.NAASales1}
        />

        <SectionHeader {...page} subheading="If no agents are available, the bot will respond with the information below." > No Agent Available - Service</SectionHeader>
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.LiveChatNAAService1}
        />
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")}
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.LiveChatNAAService2}
            enableSwitchVar={LocationVarKey.LiveChatNAAService2Enabled}
        />
        <TextAreaRow {...page}  hideIf={IS_EQUAL(LocationVarKey.HasLiveChat,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.NAAService1}
        />

        <SectionHeader {...page} subheading="If a conversation is escalated outside agent business hours, the bot will respond with the information below. ">Outside of Business Hours</SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.OutsideBusiness1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.OutsideBusiness2}
            enableSwitchVar={LocationVarKey.OutsideBusiness2Enabled}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message After Profile Confirmed"
            keyName= {LocationVarKey.OutsideBusinessConfirm1}
        />




        <SectionHeader {...page} subheading="During business hours, we will look for available agents prior to automation." hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")}>Live Chat First</SectionHeader>

        <TextRow {...page}  hideIf={IS_EQUAL(LocationVarKey.HasLiveChat,"1")} >Live Chat is currently turned off for this location. You can turn this setting on in the Details section. Even when Live Chat is turned off, we will continue to send email notifications.</TextRow>

        <SwitchRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat,"1")} keyName= {LocationVarKey.WantsLiveChatFirst} label="Live Chat First" />
        

   
        <SwitchRow {...page}  keyName= {LocationVarKey.LiveChatFirstCollectProfile} label="Collect Profile" hideIf={IS_EQUAL(LocationVarKey.WantsLiveChatFirst,"0")}/>
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.WantsLiveChatFirst,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ProfileSettingLiveChatMessage}
        />
        <DropdownRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.WantsLiveChatFirst,"1")}
        marginTop
        label=" Collection Method"
        keyName= {LocationVarKey.ProfileSettingLiveChatCollectionMethod}
        options={[
            {
                label:"Conversational",
                value:"Conversational"
            },
            {
                label:"Info Collect Card",
                value:"Card"
            }
        ]} />
        <DropdownRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.WantsLiveChatFirst,"1")}
        marginTop
        label=" Preferred Contact Method"
        keyName= {LocationVarKey.ProfileSettingLiveChatContactMethod}
        options={[
            {
                label:"Phone Number",
                value:"Phone"
            },
            {
                label:"Email",
                value:"Email"
            }
        ]} />
        <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingLiveChatWantShortProfile} hideIf={IS_NOT_EQUAL(LocationVarKey.WantsLiveChatFirst,"1")} label="Short Profile" />
        <Indent {...page} >
            <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingLiveChatWantSecondaryOptional} hideIf={IS_NOT_EQUAL(LocationVarKey.WantsLiveChatFirst,"1")} label="Make Secondary Contact Method Optional" />
        </Indent>
        <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingLiveChatWantConfirmProfile} hideIf={IS_NOT_EQUAL(LocationVarKey.WantsLiveChatFirst,"1")} label="Confirm Profile" />
        <SwitchRow {...page}  keyName= {LocationVarKey.LiveChatFirstCollectProfile} hideIf={IS_NOT_EQUAL(LocationVarKey.WantsLiveChatFirst,"1")} label="Collect Persona" />






    </>
}